import { render } from "./lhc-manual-quick.vue?vue&type=template&id=0afc6db6"
import script from "./lhc-manual-quick.vue?vue&type=script&lang=js"
export * from "./lhc-manual-quick.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__